import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { AlertType } from './types';

export const borderColorByType: Record<AlertType, string> = {
  error: theme.colors.status.critical,
  info: theme.colors.primary50,
  success: theme.colors.status.success,
  warning: theme.colors.status.warning,
};

export const textBaseStyle = css`
  display: flex;
  align-items: center;
  margin: 0;

  &::before {
    content: '';
    width: 4px;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }

  svg {
    min-width: 24px;
    margin-right: ${theme.spacing(1)};
  }
`;

export const textBeforeTypeStyles: Record<AlertType, string> = {
  error: css`
    &::before {
      background: ${theme.colors.status.critical};
      border-top-left-radius: ${theme.borderRadius.medium};
      border-bottom-left-radius: ${theme.borderRadius.medium};
    }
  `,
  info: css`
    &::before {
      background: ${theme.colors.primary50};
      border-top-left-radius: ${theme.borderRadius.medium};
      border-bottom-left-radius: ${theme.borderRadius.medium};
    }
  `,
  success: css`
    &::before {
      background: ${theme.colors.status.success};
      border-top-left-radius: ${theme.borderRadius.medium};
      border-bottom-left-radius: ${theme.borderRadius.medium};
    }
  `,
  warning: css`
    &::before {
      background: ${theme.colors.status.warning};
      border-top-left-radius: ${theme.borderRadius.medium};
      border-bottom-left-radius: ${theme.borderRadius.medium};
    }
  `,
};

export const textNewAlertStyle = css`
  &::before {
    width: 0px;
  }
`;

export const containerStyle = css`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.heavy};
  width: 100%;
  overflow: hidden;
  display: flex;
  position: relative;
  pointer-events: all;
  z-index: ${theme.zIndex.low};
`;

export const alertActionContainerStyle = css`
  border-left: 1px solid ${theme.colors.neutral50};
  padding: ${theme.spacing(0, 2)};
  margin-left: auto;
  display: flex;
  align-items: center;
  margin: ${theme.spacing(2, 0)};
`;

const sizeValue = '24px';

export const closeButtonStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  min-width: ${sizeValue};
  width: ${sizeValue};
  min-height: ${sizeValue};
  height: ${sizeValue};
  border-radius: 50px;
  padding: 0;
  font-size: initial;
  pointer-events: all;
  cursor: pointer;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.heavy};
  z-index: 2;
`;

export const actionButtonStyles = css`
  position: absolute;
  z-index: 2;
  border-radius: ${theme.spacing(2)};
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.heavy};
  pointer-events: all;
  overflow: hidden;
`;

export const alertWrapperStyle = css`
  position: relative;
  margin-bottom: ${theme.spacing(1)};
  display: flex;
  gap: ${theme.spacing(0.5)};
  width: 100%;
  border-radius: ${theme.borderRadius.medium};
`;

export const alertContentBaseStyle = css`
  padding: ${theme.spacing(2, 2, 2, 2.5)};
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${theme.spacing(2)};
`;

export const alertContentNewAlertStyle = css`
  border-width: 2px;
  border-style: solid;
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing(1.5, 1.5, 1.5, 2.5)};
  position: relative;
`;

export const alertContentNewAlertTypeStyles: Record<AlertType, string> = {
  error: css`
    border-color: ${theme.colors.status.critical};
  `,
  info: css`
    border-color: ${theme.colors.primary50};
  `,
  success: css`
    border-color: ${theme.colors.status.success};
  `,
  warning: css`
    border-color: ${theme.colors.status.warning};
  `,
};

export const alertIconWithActionStyle = css`
  margin: ${theme.spacing(1, 0)};
`;

export const alertActionButtonStyle = css`
  padding: ${theme.spacing(1)};
`;

export const alertNewAlertActionButtonStyle = css`
  font-size: ${theme.spacing(1.75)};
  cursor: pointer;
  color: ${theme.colors.neutral90};
  font-weight: ${theme.font.weight.regular};
  &:hover {
    background: ${theme.colors.white};
  }
`;
